import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHintContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 13px;
	height: 80px;
	padding: 13px 20px 17px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	pointer-events: none;
	z-index: 9999;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}

	& > ${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #000000;
	}
`;

const StyledHintRightContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledHintInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledHintInfoItem = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	.icon {
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;

		img {
			width: 12px;
			height: 12px;
			user-select: none;
			pointer-events: none;
		}
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #000000;
		white-space: nowrap;

		span {
			font-weight: 400;
			opacity: 0.5;
		}
	}
`;

export {
	StyledHintContainer,
	StyledHintInfoContainer,
	StyledHintInfoItem,
	StyledHintRightContainer,
};
